import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setInvoiceAsPaid } from "../actions/setBankTransferPaid.action";
import { invalidateAfterInvoiceChange } from "../utils/invoiceQueryInvalidation";
import { IInvoice } from "../../create/interfaces/invoice.interfaces";

export const useSetInvoiceAsPaid = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({
            invoice,
            companyId,
            method,
            transactionId,
        }: {
            invoice: IInvoice;
            companyId: number;
            method: "bank_transfer" | "cash";
            transactionId?: string | null;
        }) => setInvoiceAsPaid(invoice.uid, companyId, { method, transactionId }),
        onSuccess: (_data, variables) => {
            const jobEventUids = ((variables.invoice as any)?.billingJobEvents ?? [])
                .map((e: any) => e?.uid)
                .filter(Boolean) as string[];
            const quoteId =
                (variables.invoice as any)?.quoteId ??
                (variables.invoice as any)?.quote?.id ??
                null;

            queryClient.invalidateQueries({ queryKey: ["invoice-metrics"] });

            invalidateAfterInvoiceChange(queryClient, {
                invoiceUid: variables.invoice.uid,
                jobEventUids,
                quoteId,
            });
        },
    });
}
